import {IncludeQueryTester} from '../classes/include-query-tester';

export function includesQuery(query: string): IncludeQueryTester {
    return new IncludeQueryTester(query);
}

export function capitalize(str: string): string {
    if (typeof str === 'string' && str.length) {
        return `${str.charAt(0).toUpperCase()}${str.substr(1)}`;
    }
    return '';
}

export function toCamelCase(str: string): string {
    return str.replace(/[_\\-]([A-z])/g, function (match, found) {
        return found.toUpperCase();
    });
}

/**
 * soft typecasting to string
 * so that strings can be compared with ===
 *
 * @param value
 */
export function castToString(value: any): string {
    return '' + value;
}
